var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2315_6864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.299 11.3087C25.2984 11.3082 25.2978 11.3076 25.2972 11.307L14.6913 0.701416C14.2392 0.249146 13.6382 0 12.9988 0C12.3595 0 11.7585 0.248947 11.3062 0.701218L0.705807 11.3014C0.702236 11.305 0.698666 11.3087 0.695095 11.3123C-0.23325 12.246 -0.231663 13.7609 0.699657 14.6922C1.12515 15.1179 1.68711 15.3645 2.28796 15.3903C2.31236 15.3927 2.33696 15.3939 2.36175 15.3939H2.78447V23.1989C2.78447 24.7434 4.0411 26 5.58596 26H9.73535C10.1559 26 10.4971 25.659 10.4971 25.2383V19.1191C10.4971 18.4144 11.0703 17.8411 11.7751 17.8411H14.2225C14.9273 17.8411 15.5006 18.4144 15.5006 19.1191V25.2383C15.5006 25.659 15.8416 26 16.2623 26H20.4117C21.9566 26 23.2132 24.7434 23.2132 23.1989V15.3939H23.6052C24.2443 15.3939 24.8453 15.1449 25.2978 14.6926C26.2301 13.7597 26.2305 12.2422 25.299 11.3087Z",
    fill: "#FDFBFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2315_6864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d5514cc07aee8a2bc350468c5859beef.svg";
export { ForwardRef as ReactComponent };